<template>
<div class="login-box" style="min-height: 873px;">
    <div class="box-header with-border">

    </div>
    <div v-if="loading == false">
     <div class="row">
         <div class="center-block">

         
        <div class="login-box-body">

            <h2 class="login-box-msg" v-html="msg"> </h2>

            <center>
                <div v-bind:class="icon" style="font-size:200px;"></div>
                <input class="btn btn-primary" type="button" value="Salir" @click="close">
            </center>

        </div>
    </div>
        
         </div>
     </div>
    <div v-else>
        <center>
            <div class="fa fa-spinner fa-pulse text-blue" style="font-size:100px;"></div>
        </center>
    </div>

</div>
</template>

<script>
import swal from "sweetalert";
export default {
    name: "rejecting",
    data() {
        return {
            loading: false,
            msg: "",
            wellIcon: true
        };
    },
    created() {
        this.aprobe(this.$route.params.merchanId, this.$route.params.transactionId, this.$route.params.token);
    },
    methods: {
        async aprobe(merchanId, transactionId, token) {
            try {
                let self = this;
                this.loading = true;
                let response = await this.$store.state.services.petitionService.approve({
                    merchanId,
                    transactionId,
                    token
                });
                this.loading = false;

                this.msg = response.data.message;
                this.wellIcon = true;

                swal({
                    title: this.$t("THE STATUS HAS BEEN CHANGED"),
                    text: "",
                    icon: "success"
                });
            } catch (error) {
                self.wellIcon = false;
                this.loading = false;
                this.msg = error.response.data.error;
                swal({
                    title: this.$t("STATUS CHANGE FAILED"),
                    text: error.response.data.error,
                    icon: "success"
                });
            }
        },
        close() {
            window.close();
        }
    },
    computed: {
        icon(icon) {
            if (this.wellIcon) {
                return "fa fa-check text-blue";
            } else {
                ("fa fa-times text-blue");
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Transactions/approveMessage.vue